import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-43fccffc")

_pushScopeId("data-v-43fccffc")
const _hoisted_1 = { class: "text-style-panel" }
const _hoisted_2 = { class: "preset-style" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "行间距：", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "字间距：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Divider = _resolveComponent("Divider")
  const _component_IconFontSize = _resolveComponent("IconFontSize")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_SelectOptGroup = _resolveComponent("SelectOptGroup")
  const _component_Select = _resolveComponent("Select")
  const _component_IconAddText = _resolveComponent("IconAddText")
  const _component_InputGroup = _resolveComponent("InputGroup")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_IconText = _resolveComponent("IconText")
  const _component_Button = _resolveComponent("Button")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Popover = _resolveComponent("Popover")
  const _component_IconBackgroundColor = _resolveComponent("IconBackgroundColor")
  const _component_IconFill = _resolveComponent("IconFill")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")
  const _component_IconTextBold = _resolveComponent("IconTextBold")
  const _component_CheckboxButton = _resolveComponent("CheckboxButton")
  const _component_IconTextItalic = _resolveComponent("IconTextItalic")
  const _component_IconTextUnderline = _resolveComponent("IconTextUnderline")
  const _component_IconStrikethrough = _resolveComponent("IconStrikethrough")
  const _component_CheckboxButtonGroup = _resolveComponent("CheckboxButtonGroup")
  const _component_IconUpOne = _resolveComponent("IconUpOne")
  const _component_IconDownOne = _resolveComponent("IconDownOne")
  const _component_IconCode = _resolveComponent("IconCode")
  const _component_IconQuote = _resolveComponent("IconQuote")
  const _component_IconFormat = _resolveComponent("IconFormat")
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_IconList = _resolveComponent("IconList")
  const _component_IconOrderedList = _resolveComponent("IconOrderedList")
  const _component_IconRowHeight = _resolveComponent("IconRowHeight")
  const _component_IconFullwidth = _resolveComponent("IconFullwidth")
  const _component_ElementOutline = _resolveComponent("ElementOutline")
  const _component_ElementShadow = _resolveComponent("ElementShadow")
  const _component_ElementOpacity = _resolveComponent("ElementOpacity")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.presetStyles, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "preset-style-item",
          key: item.label,
          style: item.style,
          onClick: ($event: any) => (_ctx.emitBatchRichTextCommand(item.cmd))
        }, _toDisplayString(item.label), 13, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_Divider),
    _createVNode(_component_InputGroup, {
      compact: "",
      class: "row"
    }, {
      default: _withId(() => [
        _createVNode(_component_Select, {
          style: {"flex":"3"},
          value: _ctx.richTextAttrs.fontname,
          onChange: _cache[1] || (_cache[1] = value => _ctx.emitRichTextCommand('fontname', value))
        }, {
          suffixIcon: _withId(() => [
            _createVNode(_component_IconFontSize)
          ]),
          default: _withId(() => [
            _createVNode(_component_SelectOptGroup, { label: "系统字体" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableFonts, (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withId(() => [
                      _createVNode("span", {
                        style: { fontFamily: font.value }
                      }, _toDisplayString(font.label), 5)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_SelectOptGroup, { label: "在线字体" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webFonts, (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withId(() => [
                      _createVNode("span", null, _toDisplayString(font.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_Select, {
          style: {"flex":"2"},
          value: _ctx.richTextAttrs.fontsize,
          onChange: _cache[2] || (_cache[2] = value => _ctx.emitRichTextCommand('fontsize', value))
        }, {
          suffixIcon: _withId(() => [
            _createVNode(_component_IconAddText)
          ]),
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fontSizeOptions, (fontsize) => {
              return (_openBlock(), _createBlock(_component_SelectOption, {
                key: fontsize,
                value: fontsize
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(fontsize), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withId(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.richTextAttrs.color,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = value => _ctx.emitRichTextCommand('color', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字颜色"
            }, {
              default: _withId(() => [
                _createVNode(_component_Button, {
                  class: "text-color-btn",
                  style: {"flex":"1"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_IconText),
                    _createVNode("div", {
                      class: "text-color-block",
                      style: { backgroundColor: _ctx.richTextAttrs.color }
                    }, null, 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withId(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.richTextAttrs.backcolor,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = value => _ctx.emitRichTextCommand('backcolor', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字高亮"
            }, {
              default: _withId(() => [
                _createVNode(_component_Button, {
                  class: "text-color-btn",
                  style: {"flex":"1"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_IconBackgroundColor),
                    _createVNode("div", {
                      class: "text-color-block",
                      style: { backgroundColor: _ctx.richTextAttrs.backcolor }
                    }, null, 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withId(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.fill,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = value => _ctx.updateFill(value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文本框填充"
            }, {
              default: _withId(() => [
                _createVNode(_component_Button, {
                  class: "text-color-btn",
                  style: {"flex":"1"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_IconFill),
                    _createVNode("div", {
                      class: "text-color-block",
                      style: { backgroundColor: _ctx.fill }
                    }, null, 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "加粗"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.bold,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitRichTextCommand('bold')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconTextBold)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "斜体"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.em,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitRichTextCommand('em')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconTextItalic)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下划线"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.underline,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emitRichTextCommand('underline')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconTextUnderline)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "删除线"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.strikethrough,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emitRichTextCommand('strikethrough')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconStrikethrough)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "上标"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.superscript,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.emitRichTextCommand('superscript')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconUpOne)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下标"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.subscript,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emitRichTextCommand('subscript')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconDownOne)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "行内代码"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.code,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.emitRichTextCommand('code')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconCode)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "引用"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.blockquote,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitRichTextCommand('blockquote')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconQuote)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "清除格式"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.emitRichTextCommand('clear')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconFormat)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    _createVNode(_component_RadioGroup, {
      class: "row",
      "button-style": "solid",
      value: _ctx.richTextAttrs.align,
      onChange: _cache[15] || (_cache[15] = e => _ctx.emitRichTextCommand('align', e.target.value))
    }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_RadioButton, {
              value: "left",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTextLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "居中"
        }, {
          default: _withId(() => [
            _createVNode(_component_RadioButton, {
              value: "center",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTextCenter)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_RadioButton, {
              value: "right",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTextRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "项目符号"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.bulletList,
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.emitRichTextCommand('bulletList')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconList)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "编号"
        }, {
          default: _withId(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _ctx.richTextAttrs.orderedList,
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.emitRichTextCommand('orderedList')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconOrderedList)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: _ctx.lineHeight,
        onChange: _cache[18] || (_cache[18] = value => _ctx.updateLineHeight(value))
      }, {
        suffixIcon: _withId(() => [
          _createVNode(_component_IconRowHeight)
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lineHeightOptions, (item) => {
            return (_openBlock(), _createBlock(_component_SelectOption, {
              key: item,
              value: item
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item) + "倍", 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: _ctx.wordSpace,
        onChange: _cache[19] || (_cache[19] = value => _ctx.updateWordSpace(value))
      }, {
        suffixIcon: _withId(() => [
          _createVNode(_component_IconFullwidth)
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.wordSpaceOptions, (item) => {
            return (_openBlock(), _createBlock(_component_SelectOption, {
              key: item,
              value: item
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item) + "px", 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementOutline),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementShadow),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementOpacity)
  ]))
})